var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home-bed"},[_c('div',{staticClass:"img-bed"},[_c('black-bar',{attrs:{"ifCanBack":false,"title":"支付结果"}})],1),_c('img',{staticStyle:{"margin-top":"4vh"},attrs:{"src":_vm.waiting,"alt":""}}),_c('p',[_vm._v("正在处理")]),_c('p',{staticClass:"result"},[_vm._v("正在查询本次支付结果")])])
}
var staticRenderFns = []

export { render, staticRenderFns }